import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';
import { UiLinkComponent } from '@big-direkt/ui/link';
import { UiListComponent, type ListItemModel } from '@big-direkt/ui/list';
import { EnvironmentService } from '@big-direkt/utils/environment';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { SearchResultTrackingDirective } from '../../directives/search-result-tracking.directive';
import { type SearchResult } from '../../models/search-result';
import { ResultItemComponent } from './result-item/result-item.component';

@Component({
    selector: 'big-search-result',
    templateUrl: './result.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ResultItemComponent, UiListComponent, UiLinkComponent, TranslocoDirective, SearchResultTrackingDirective],
})
export class ResultComponent {
    private readonly environmentService = inject(EnvironmentService);
    private readonly transloco = inject(TranslocoService);

    public readonly servicePhoneNumber = this.environmentService.servicePhoneNumber;

    @HostBinding('class') @Input() public classList = 'block';
    @Input() public result!: SearchResult;
    @Input() public searchTerm!: string;
    @Input() public currentPage!: number;

    public emptyResultList: ListItemModel[] = [
        {
            link: { href: '', title: '', target: '' },
            text: this.transloco.translate('search.emptyResultList.check'),
            title: '',
        },
        {
            link: { href: '', title: '', target: '' },
            text: this.transloco.translate('search.emptyResultList.change'),
            title: '',
        },
        {
            link: { href: '', title: '', target: '' },
            text: this.transloco.translate('search.emptyResultList.reduce'),
            title: '',
        },
        {
            link: { href: '', title: '', target: '' },
            text: this.transloco.translate('search.emptyResultList.specialChairs'),
            title: '',
        },
    ];
}
